import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../components/Login/Login";
import AdminHomepage from "../pages/AdminHomepage/AdminHomepage";
import AdminInfo from "../pages/AdminInfomation/AdminInfo";
import ListClients from "../components/ListUsers/ListClients";
import ListEmployees from "../components/ListUsers/ListEmployees";
import AdminParkingLot from "../pages/AdminParkingLot/AdminParkingLot";
import AdminRevenue from "../pages/AdminRevenue/AdminRevenue";
import AdminEWallet from "../pages/AdminEWallet/AdminEWallet";
import AdminVehicles from "../pages/AdminVehicles/AdminVehicles";
import AdminMembershipManage from "../pages/AdminMembershipManage/AdminMembershipManage";
import NotFound from "../pages/NotFound/NotFound";

const AppRoute = () => {
    return (
        <Routes>
            <Route path="/" element={<AdminHomepage />} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin/parkinglot" element={<AdminParkingLot />} />
            <Route path="/admin/revenue" element={<AdminRevenue />} />
            <Route path="/admin/ewallet" element={<AdminEWallet />} />
            <Route path="/admin/vehicles" element={<AdminVehicles />} />
            <Route path="/admin/membership-manage" element={<AdminMembershipManage />} />
            <Route path="/admin/infomation" element={<AdminInfo />} />
            <Route path="/admin/listUser" element={<ListClients />} />
            <Route path="/admin/listEmployee" element={<ListEmployees />} />
            <Route path="/admin/user-infomation" element={<AdminInfo />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default AppRoute;
